export default "__VITE_ASSET__DNzZ3Y2R__"